import { logger } from '../../../../../utils/common/logger'

export enum LRWidgetType {
    FORGOT_PASSWORD = 'forgotPassword',
    LOGIN = 'login',
    SOCIAL_LOGIN = 'socialLogin',
    REGISTRATION = 'registration',
    VERIFY_EMAIL = 'verifyEmail',
    RESET_PASSWORD = 'resetPassword'
}

export enum IdentityScreen {
    SUCCESS = 'identity-screen-success--active',
    ERROR = 'identity-screen-error--active',
    FORM = 'identity-screen-form--active'
}

export interface ILRWidgetOptions {
    container: string
    templateName?: string
    onError(response: object): void
    onSuccess(errors: object): void
}

export abstract class LoginRadiusWidget {
    protected widgetType: LRWidgetType
    protected lrObject: any
    protected container: string

    /**
     * This function will initialize the LR widget that is used to generate the registration forms
     * reference: https://www.loginradius.com/docs/libraries/js-libraries/js-form-library/
     * reference: https://www.loginradius.com/docs/libraries/identity-experience-framework/customization/
     */
    public initForm() {
        if (document.querySelector(`#${this.container}`)) {
            logger('debug', `Initializing ${this.widgetType} widget`)
            const widgetOptions = {
                container: this.container,
                onError: this.onError,
                onSuccess: this.onSuccess
            } as ILRWidgetOptions

            // insert widget into the div container
            this.lrObject.init(this.widgetType, widgetOptions)
            logger('debug', `${this.widgetType} widget initialized`)
        }
    }

    protected abstract onSuccess(response: object): void
    protected abstract onError(errors: object): void
}
